import { render, staticRenderFns } from "./ClassMian.vue?vue&type=template&id=fcd61ec6&scoped=true"
import script from "./ClassMian.vue?vue&type=script&lang=js"
export * from "./ClassMian.vue?vue&type=script&lang=js"
import style0 from "./ClassMian.vue?vue&type=style&index=0&id=fcd61ec6&prod&scoped=true&lang=css"
import style1 from "./ClassMian.vue?vue&type=style&index=1&id=fcd61ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd61ec6",
  null
  
)

export default component.exports